import React from 'react';
import { motion } from 'motion/react';

const GALLERY_IMAGES = [
  {
    src: "https://lh3.googleusercontent.com/d/1NW796vGzF7aQWL3Ev9x40V7vJ0CHoFof",
    alt: "Farm View 1",
    className: "md:col-span-2 md:row-span-2"
  },
  {
    src: "https://lh3.googleusercontent.com/d/1E_Sm1ZE3cJ9VakTGmhLrk4Q80JDPN0I7",
    alt: "Farm View 2",
    className: "md:col-span-1 md:row-span-1"
  },
  {
    src: "https://lh3.googleusercontent.com/d/1CB3YPYpsz0OyrS0IwO6waA7a4Gs_ClK_",
    alt: "Farm View 3",
    className: "md:col-span-1 md:row-span-1"
  },
  {
    src: "https://lh3.googleusercontent.com/d/12nUeS2nlQ5PHfZL0ahYd2LTZE4f0jVMf",
    alt: "Farm View 4",
    className: "md:col-span-1 md:row-span-1"
  },
  {
    src: "https://lh3.googleusercontent.com/d/16xi0kzspCeoATfbE2i8MdI15TLNyYkm4",
    alt: "Farm View 5",
    className: "md:col-span-1 md:row-span-1"
  }
];

export const GallerySection: React.FC = () => {
  return (
    <section id="gallery" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-heading font-bold text-gray-900 mb-4">Our Gallery</h2>
          <div className="h-1 w-20 bg-avo-gold mx-auto rounded-full mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Take a visual journey through our farms, processes, and the premium quality products we deliver.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 auto-rows-[200px]">
          {GALLERY_IMAGES.map((img, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className={`relative group overflow-hidden rounded-2xl ${img.className}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
                referrerPolicy="no-referrer"
              />
              <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
                <span className="text-white font-bold font-heading text-lg tracking-wide translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                  {img.alt}
                </span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
